import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CorporateActionsCollection } from '../../Models/Domains/Transactions/CorporateAction/CorporateActionsCollection';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class DividendSummaryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, fromDate: IJsonDate, toDate: IJsonDate, fromInception: boolean, instrumentCode: string, corpActionType: string, sortName: string, sortDirection: string, minRow: number, maxRow: number): Promise<CorporateActionsCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/DividendSummary/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fromDate: fromDate, toDate: toDate, fromInception: fromInception, instrumentCode: instrumentCode, corpActionType: corpActionType, sortName: sortName, sortDirection: sortDirection, minRow: minRow, maxRow: maxRow }

    return AjaxWrapper.get<CorporateActionsCollection, any>(url, data);
  }
}

